import { atom } from "jotai";

import { PatronEditBooking } from "../../../types";
import { currentBookingAtom } from "../../stores";

/**
 * Write-only atom for updating request info in the booking
 */
export const setRequestInfoAtom = atom(
  null, // read function returns null (not used)
  (get, set, updatedRequestInfo: Partial<PatronEditBooking.RequestInfo>) => {
    const booking = get(currentBookingAtom);

    // If no booking, can't update
    if (!booking) return;

    // Get current request info or use default if not present
    const currentRequestInfo = booking.request
      ? {
          time: booking.request.time,
          minTime: booking.request.minTime,
          maxTime: booking.request.maxTime,
        }
      : undefined;

    // Create the updated request info by merging current and updated values
    const newRequestInfo = {
      ...currentRequestInfo,
      ...updatedRequestInfo,
    };

    // Update the booking with the new request info
    set(currentBookingAtom, {
      ...booking,
      request: newRequestInfo,
    });
  }
);
